module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"pitpay-web","short_name":"pitpay","start_url":"/","background_color":"#00001F","theme_color":"#00001F","display":"minimal-ui","icon":"src/images/PitPayFav.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e52a09f0a88f22217e63dc994c012fe5"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
